import * as z from "zod/v4";

const ParsedAddress_ = z.object({
  street1: z.string().describe("First line of the street address"),
  street2: z.string().describe("Second line of the street address"),
  city: z.string().describe("City name"),
  state: z.string().describe("State or province"),
  postalCode: z.string().describe("ZIP or postal code"),
  country: z.string().describe("Country name or code"),
});
export interface ParsedAddress extends z.infer<typeof ParsedAddress_> {}
export const ParsedAddress: z.ZodType<ParsedAddress> = ParsedAddress_;

export const parseAddresses = {
  name: "parseAddresses" as const,
  input: z.object({
    addresses: z
      .array(z.string())
      .describe("Array of full address strings to parse into components"),
  }),
  output: z.object({
    parsedAddresses: z
      .array(ParsedAddress)
      .describe("Array of parsed address components"),
  }),
};
